export const chartColors = [
    '#f9c700',
    '#ff8c00',
    '#ff6384',
    '#36a2eb',
    '#ffce56',
    '#4bc0c0',
    '#96f',
    '#c9cbcf',
    '#ffd700',
    '#ff4500',
    '#ff1493',
    '#00bfff',
    '#ffd700',
    '#0f0',
    '#f00',
    '#00f',
    '#f0f',
    '#800000',
    '#808000',
    '#008000',
    '#008080',
    '#000080',
    '#800080',
];
